import { UIHeading4 } from '@cian/ui-kit/typography';

import { clsx } from 'clsx';
import { type ButtonHTMLAttributes, type FC, type ReactElement } from 'react';

import { type TButtonTheme, type TTextColor } from './types';

import styles from './Button.css';

interface IButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactElement;
  size?: 'small';
  theme?: TButtonTheme;
  testId?: string;
  disabled?: boolean;
}

const textColor: TTextColor = {
  blue: 'accent-main-primary',
  orange: 'theme-white',
};

export const Button: FC<IButton> = (props: IButton) => {
  const { type = 'button', onClick, children, icon, size, theme = 'orange', testId, disabled } = props;
  const color = textColor[theme];

  return (
    <button
      className={clsx(
        styles['button'],
        { [styles['button_small']]: size === 'small' },
        { [styles['button_blue']]: theme === 'blue' },
      )}
      data-testid={testId}
      disabled={disabled}
      type={type}
      onClick={onClick}
    >
      {icon && <span className={styles['button__icon']}>{icon}</span>}
      <UIHeading4 color={color} fontWeight="bold">
        {children}
      </UIHeading4>
    </button>
  );
};
